import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import React from "react";
import { useSelector } from "react-redux";
import dpInterestDi from "@frameworks/web/components/Reports/DpInterest/di/servicelocator";
import DpInterestExtensionMob from "./DpInterestExtensionMob";
import Common_Shimmer from "@frameworks/web/components/features/Markets/Equity/Equityshimmer/common_shimmer";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/web/components/generic/error";
export const threePaths = Array(3)
    .fill("")
    .map((_, idx) => React.createElement("span", { key: idx, className: `path${idx + 1}` }));
const DpInterestMobileTable = (props) => {
    var _a;
    const { reducersData: dpiCharges, commonData: chargesCommonData } = useSelector((state) => state.DpInterest.dpiCharges);
    const [selectedMonthYear, setSelectedMonthYear] = React.useState("");
    const [extensionDrawer, setExtensionDrawer] = React.useState(false);
    const selectedFamilyMember = useSelector((state) => { var _a, _b, _c; return (_c = (_b = (_a = state.FamilyTagging.familyDetails) === null || _a === void 0 ? void 0 : _a.reducersData) === null || _b === void 0 ? void 0 : _b.selectedMember) === null || _c === void 0 ? void 0 : _c.accCode; });
    const contentDrawerOpen = (month) => {
        let payload = {
            dpType: props.dpType,
            month: month,
            accCode: selectedFamilyMember,
        };
        dpInterestDi.dpInterest.getDpInterestDetails(payload);
        setExtensionDrawer(true);
        setSelectedMonthYear(month);
    };
    return (React.createElement(React.Fragment, null, chargesCommonData.loader ? (React.createElement(Common_Shimmer, null)) : chargesCommonData.errorData.isOpen ? (React.createElement(ErrorNotification, { error: chargesCommonData.errorData.error, isOpen: chargesCommonData.errorData.isOpen, displayType: ErrorDisplayType.INSECTION })) : chargesCommonData.message.show ? (React.createElement("div", { className: "error-msg-new-icon" },
        React.createElement(Errormsg, { customMsg: React.createElement("div", { className: "DMSan_14_700 txt-midnight-blue lh-140" },
                "No results found!",
                React.createElement("div", { className: "DMSanN_14_400 txt_secondary-gray" }, "Try searching for something else")), paths: threePaths, icon: "edel-icon-reports-note" }))) : (React.createElement(React.Fragment, null,
        React.createElement("table", { className: "table table-border dp-interest-table" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Month- Year"),
                    React.createElement("th", null, "Interest amount"))),
            React.createElement("tbody", null, (_a = dpiCharges === null || dpiCharges === void 0 ? void 0 : dpiCharges.dpiCharges) === null || _a === void 0 ? void 0 : _a.map((item) => {
                const isTotal = item.monthYear === "Total";
                return (React.createElement("tr", { key: item.monthYear, className: isTotal ? "bg_lightYellow" : "" },
                    React.createElement("td", { className: `${!isTotal &&
                            Number(item.interestAmount.replace(/,/g, "")) > 0
                            ? "txt-underline"
                            : ""}`, onClick: () => {
                            if (!isTotal &&
                                Number(item.interestAmount.replace(/,/g, "")) > 0) {
                                contentDrawerOpen(item.monthYear);
                            }
                        } }, item.monthYear.replace(" - ", " ")),
                    React.createElement("td", null, item.interestAmount)));
            }))),
        React.createElement(GenericDrawer, { show: extensionDrawer, setShow: setExtensionDrawer, parentClass: "new-background-blur bg_aqua_white dpinterest-extension-drawer z-index-high", headerComp: selectedMonthYear, bodyComp: React.createElement(DpInterestExtensionMob, null) })))));
};
export default DpInterestMobileTable;
